<!--
  author：Zoufx
  description：角色
  date：2020/9/3
-->
<template>
  <el-container>
    <el-drawer title="角色" :visible="formVisible" :before-close="handleClose" append-to-body :wrapperClosable="false"
               @open="handleOpen">
      <el-row style="padding: 30px">
        <el-form ref="form" :model="form" :rules="rules" label-width="90px">
          <el-form-item label="角色名称" prop="roleName">
            <el-input v-model="form.roleName" placeholder="请输入角色名称" size="medium"/>
          </el-form-item>
          <el-form-item label="编码" prop="code">
            <el-input v-model="form.code" placeholder="请输入编码" size="medium"/>
          </el-form-item>
          <el-form-item label="级别" prop="level">
            <el-input-number v-model.number="form.level" :min="0" :max="999" placeholder="请输入级别" size="medium" />
          </el-form-item>
          <el-form-item label="备 注">
            <el-input type="textarea" rows="10" v-model="form.remarks" placeholder="请输入备注"/>
          </el-form-item>
        </el-form>
      </el-row>
      <el-row class="drawer_footer">
        <el-button type="primary" @click="submit" :disabled="$store.state.loading" size="medium">确 定</el-button>
        <el-button @click="handleClose" :disabled="$store.state.loading" size="medium">取 消</el-button>
      </el-row>
    </el-drawer>
  </el-container>
</template>

<script>
  import {commonFormMixin} from "../../../utils/commonFormMixin";

  export default {
    name: 'SysRoleForm',
    mixins: [commonFormMixin],
    data() {
      const checkCodeExist = async (rule, value, callback) => {
        if (!value) {
          return callback();
        }
        let params = {code: value};
        if (this.form.id) params.id = this.form.id;
        let {obj} = await this.postRequest('/sysRole/codeExist', params);
        return obj ? callback(new Error('编码已存在')) : callback()
      };
      return {
        form: {},
        rules: {
          roleName: [
            {required: true, message: '请输入角色名称', trigger: 'blur'},
          ],
          code: [
            {max:20, message:'长度不能超过20位', trigger: 'blur'},
          ],
          code: [
            {max:20, message:'长度不能超过20位', trigger: 'blur'},
            {validator: checkCodeExist, trigger: 'change'}
          ],
        }
      }
    }
  }
</script>

<style scoped>

</style>
